module.exports = __webpack_public_path__ + "img/12.b7f16dfe.png";